import {
  FETCH_OPERATOR_MASTER,
  GET_OPERATOR_MASTER,
  ADD_OPERATOR_MASTER,
  UPDATE_OPERATOR_MASTER,
  DELETE_OPERATOR_MASTER,
} from 'actions/operatorMaster';
import * as _ from 'lodash';
import { toast } from 'react-toastify';

const initialState = {
  isLoading: false,
  operatorMasters: [],
  operatorMasterDetail: {},
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const operatorMasterReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_OPERATOR_MASTER.REQUEST:
    case GET_OPERATOR_MASTER.REQUEST:
    case ADD_OPERATOR_MASTER.REQUEST:
    case DELETE_OPERATOR_MASTER.REQUEST: {
      return { ...state, isLoading: true, operatorMasterDetail: {} };
    }

    case UPDATE_OPERATOR_MASTER.REQUEST: {
      return { ...state, isLoading: true };
    }

    case FETCH_OPERATOR_MASTER.SUCCESS: {
      const results = Array.isArray(payload) ? payload : payload?.results || [];
      return {
        ...state,
        isLoading: false,
        operatorMasters: results,
        page: payload?.page || 1,
        limit: payload?.limit || 10,
        totalPages: payload?.totalPages || 1,
        total: payload?.totalResults || results.length,
      };
    }

    case GET_OPERATOR_MASTER.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        operatorMasterDetail: payload,
      };
    }

    case ADD_OPERATOR_MASTER.SUCCESS: {
      toast.success('Operator master added successfully');
      return {
        ...state,
        isLoading: false,
        operatorMasters: _.concat(state.operatorMasters, payload),
      };
    }

    case UPDATE_OPERATOR_MASTER.SUCCESS: {
      toast.success('Operator master updated successfully');
      return {
        ...state,
        operatorMasters: state.operatorMasters.map((data) =>
          (data.id || data._id) === (payload.id || payload._id) ? payload : data,
        ),
        isLoading: false,
      };
    }

    case DELETE_OPERATOR_MASTER.SUCCESS: {
      toast.success('Operator master deleted successfully');
      return {
        ...state,
        isLoading: false,
        operatorMasters: state.operatorMasters.filter(
          (data) => (data.id || data._id) !== payload,
        ),
      };
    }

    case FETCH_OPERATOR_MASTER.FAIL:
    case GET_OPERATOR_MASTER.FAIL:
    case ADD_OPERATOR_MASTER.FAIL:
    case UPDATE_OPERATOR_MASTER.FAIL:
    case DELETE_OPERATOR_MASTER.FAIL: {
      return { ...state, isLoading: false };
    }

    default:
      return { ...state };
  }
};

export default operatorMasterReducer;
